export default __webpack_public_path__ + "static/media/placeholder.330fc7e9.png";